export default __webpack_public_path__ + "static/media/Get-Care-mWeb.5303ca87.png";